// Udyan 28 Sep: sticky Add to Cart bar (mobile only). Markup: snippets/ut-sticky-atc.liquid.
// The main variant picker and Add to Cart button stay the source of truth; this bar only mirrors and clicks them.
(function () {
  var bar = document.getElementById('ut-sticky-atc');
  if (!bar) return;
  var sectionId = bar.dataset.section;
  var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
  if (!mainButton) return;

  var add = bar.querySelector('.ut-sticky-atc__add');
  var cta = bar.querySelector('.ut-sticky-atc__cta');
  var priceEl = bar.querySelector('.ut-sticky-atc__price');
  var picker = bar.querySelector('.ut-sticky-atc__picker');
  var sheet = document.getElementById('ut-variant-sheet');
  var mobile = window.matchMedia('(max-width: 749px)');

  function setVisible(show) {
    show = show && mobile.matches;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    bar.inert = !show;
    document.body.classList.toggle('ut-sticky-on', show);
    if (show) document.documentElement.style.setProperty('--ut-sticky-h', bar.offsetHeight + 'px');
  }

  // Show once the main Add to Cart button has scrolled above the viewport; hide when it is back.
  var shown = null;
  function check() {
    var btn = document.getElementById('ProductSubmitButton-' + sectionId) || mainButton;
    var show = btn.getBoundingClientRect().bottom < 0 && mobile.matches;
    if (show === shown) return;
    shown = show;
    setVisible(show);
  }
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  check();

  add.addEventListener('click', function () {
    var real = document.getElementById('ProductSubmitButton-' + sectionId);
    if (real && !real.disabled) real.click();
  });

  // Udyan 2 Oct: the sheet slides down before it closes (CSS .is-closing in assets/ut-pdp.css)
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function closeSheet() {
    if (!sheet.open || sheet.classList.contains('is-closing')) return;
    if (reduceMotion.matches) {
      sheet.close();
      return;
    }
    sheet.classList.add('is-closing');
    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      sheet.close();
      sheet.classList.remove('is-closing');
    };
    sheet.addEventListener('animationend', function onEnd(ev) {
      if (ev.target !== sheet || ev.pseudoElement) return;
      sheet.removeEventListener('animationend', onEnd);
      finish();
    });
    setTimeout(finish, 400);
  }

  if (sheet && picker) {
    picker.addEventListener('click', function () {
      sheet.showModal();
    });
    sheet.addEventListener('cancel', function (ev) {
      ev.preventDefault();
      closeSheet();
    });
    sheet.addEventListener('click', function (ev) {
      var opt = ev.target.closest('[data-value]');
      if (opt) {
        var inputs = document.querySelectorAll('#MainProduct-' + sectionId + ' variant-selects input[type="radio"]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === opt.dataset.value) {
            inputs[i].click();
            break;
          }
        }
        closeSheet();
      } else if (ev.target === sheet || ev.target.closest('.ut-sheet__close')) {
        closeSheet();
      }
    });
  }

  function currentPriceText() {
    var wrap = document.getElementById('price-' + sectionId);
    if (!wrap) return null;
    var el = wrap.querySelector('.price--on-sale .price-item--sale') || wrap.querySelector('.price__regular .price-item--regular');
    return el ? el.textContent.trim() : null;
  }

  function sync(variant) {
    var real = document.getElementById('ProductSubmitButton-' + sectionId);
    var soldOut = !real || real.disabled;
    if (variant && typeof variant.available === 'boolean') soldOut = !variant.available;

    add.disabled = soldOut;
    cta.textContent = soldOut ? 'Sold out' : 'Add to cart';
    var price = currentPriceText();
    if (price) priceEl.textContent = price;

    if (picker && variant) {
      var label = picker.querySelector('.ut-sticky-atc__label');
      var value = picker.querySelector('.ut-sticky-atc__value');
      label.textContent = label.dataset.base + (soldOut ? ' · Sold out' : '');
      value.textContent = variant.option1;
    }
    if (sheet && variant) {
      sheet.querySelectorAll('[data-value]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.value === variant.option1));
      });
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data ? event.data.variant : null;
      setTimeout(function () {
        sync(variant);
      }, 0);
    });
  }

  if (mobile.addEventListener) {
    mobile.addEventListener('change', function () {
      shown = null;
      check();
    });
  }
})();
